"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
// global.Promise = require('es6-promise').Promise;
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
require("toggle-aria");
require("jquery.simplyscroll.min");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var extend_link_1 = __importDefault(require("extend-link"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("swipe-elem");
require("toggler");
require("expander");
require("toggle-expander");
var stickyer_1 = __importDefault(require("stickyer"));
require("swipe-elem");
require("tab.ts");
require("@fancyapps/fancybox");
var menu_1 = __importDefault(require("menu"));
var objectFitImages = require('object-fit-images');
var accordion_1 = __importDefault(require("accordion"));
var top_1 = require("top");
var lh = "";
lh = location.href;
if (lh.match(/dcmsadm/)) {
}
else {
    hasher_1.default();
    $(function () {
        $(window).on('CSSLoad', function () {
            $('body').attr('aria-busy', 'false');
        });
        menu_1.default();
        // new cloneHeader()
        new stickyer_1.default();
        new extend_link_1.default('.biggerlink, .common_pagelink_item, .common_cases');
        tel_handler_1.default();
        slide_scroll_1.default({
            easing: 'easeOutExpo',
            speed: 700,
            not: '.not_scroll, .l_menu_btn a, .common_features_item a, .cl_tab_nav_item a'
        });
        $('.common_swipe').swipeElem({
            width: 700
        });
        $().fancybox({
            selector: '.common_fancy',
            buttons: ['close']
        });
        accordion_1.default();
        // objectFitImages('img.objectfit, img.top_bg_img, img.top_howto_nav_bg_img', { watchMQ: true });
        objectFitImages('.objectfit > img', { watchMQ: true });
        objectFitImages('.common_case_img > img', { watchMQ: true });
        $('#zip2').on('keyup', function () {
            AjaxZip3.zip2addr('zip1', 'zip2', 'pref', 'addr');
        });
        top_1.caseStudy();
        $('.cl_tab').each(function (i, elem) {
            var $nav = $(elem).find('.cl_tab_nav');
            var $item = $nav.children('.cl_tab_nav_item');
            var $a = $item.children('a');
            var $inner = $(elem).find('.cl_tab_inner');
            $a.on('click', function (e) {
                e.preventDefault();
                if (!$(e.currentTarget).parent('.cl_tab_nav_item').is('.-current')) {
                    var target = $(e.currentTarget).attr('href');
                    $item.removeClass('-current');
                    $inner.removeClass('-current');
                    $(e.currentTarget).parent('.cl_tab_nav_item').addClass('-current');
                    $(target).addClass('-current');
                }
                ;
            });
        });
        $('.l_assist_search_btn').on('click', function (e) {
            if (util.viewport !== 'phone' && util.viewport !== 'tablet') {
                if ($('.l_assist_search').is('.-open')) {
                    if ($('.l_assist_search_keywords input[type="text"]').val() == '') {
                        e.preventDefault();
                        $('.l_assist_search').removeClass('-open');
                    }
                    else {
                        return e;
                    }
                    ;
                }
                else {
                    e.preventDefault();
                    $('.l_assist_search').addClass('-open');
                }
                ;
            }
            else {
                return e;
            }
            ;
        });
    });
}
;
